<template>
  <section class="content-block lg:pb-3" v-if="count >= 2">
    <div>
      <div class="vlx-container gap-0 lg:hidden text-center">
        <h2><slot name="heading"></slot></h2>
        <div class="text-editor">
            <slot name="body"></slot>
        </div>
      </div>
       <div class="aspect-w-16 aspect-h-9 sm:aspect-w-18 sm:aspect-h-6">
        <div v-for="(img, index) in images" :key="index">
          <template v-if="index === 0">
            <img
              :src="img.desktop"
              alt="image"
              class="lazy w-full h-full object-cover hidden lg:block z-10"
            />
            <img
              :src="img.mobile"
              alt="image"
              class="lazy w-full h-full object-cover lg:hidden z-10"
            />
          </template>
          <template v-else>
            <img
              :src="img.desktop"
              :style="'opacity: ' + calculateValue(index)"
              alt="image"
              class="lazy w-full h-full object-cover hidden lg:block z-10 transition-opacity duration-500"
            />
            <img
              :src="img.mobile"
              :style="'opacity: ' + calculateValue(index)"
              alt="image"
              class="lazy w-full h-full object-cover lg:hidden z-10 transition-opacity duration-500"
            />
          </template>
        </div>
      </div>

      <div
        class="sm:max-w-md sm:mx-auto lg:flex lg:transform lg:justify-between lg:-translate-y-1/3 lg:top-1/3 lg:bg-velux-white lg:max-w-screen-lg lg:text-velux-grey-900 z-20 relative lg:shadow-md"
      >
        <div
          class="hidden lg:flex lg:flex-wrap lg:flex-col lg:w-full lg:pr-6 lg:py-6 lg:pl-12 lg:-ml-1"
        >
          <div role="heading" aria-level="2" class="text-3xl font-normal mb-3">
              <slot name="heading"></slot>
          </div>
          <div class="text-editor">
              <slot name="body"></slot>
          </div>
        </div>
        <div class="px-2 lg:px-0">
          <div
            class="mx-auto relative transform lg:transform-none -translate-y-1/2 top-1/2 lg:flex lg:items-center lg:content-center lg:flex-wrap lg:top-0 bg-velux-grey-900 px-20 py-3 sm:py-6 lg:py-7 z-20 lg:mr-0 text-center max-w-sm h-full"
          >
            <label
              for="range-before-after"
              class="text-velux-white sm:mb-4 lg:mb-3 block min-w-full"
            >
               <slot name="label"></slot>
            </label>
            <div class="relative flex items-center w-full">
              <div
                class="absolute h-2 rounded-lg overflow-hidden absolute -left-8 -right-8 transform -translate-y-1/2 top-1/2 bg-velux-white min-w-full flex justify-between"
              >
                <div role="button" @click="jumpToMin" class="w-8"></div>
                <div role="button" @click="jumpToMax" class="w-8"></div>
              </div>
              <input
                ref="rangeSlider"
                id="range-before-after"
                type="range"
                class="w-full lg:w-64 h-8 opacity-0 appearance-none cursor-pointer"
                :step="100 / (images.length - 1)"
                min="0"
                max="100"
                v-model="rangeValue"
              />
              <div
                class="w-full lg:w-64 h-2 rounded-lg overflow-hidden absolute left-0 right-0 transform -translate-y-1/2 top-1/2 bg-velux-white pointer-events-none"
              ></div>

              <div
                role="slider"
                tabindex="0"
                :style="`left: ${rangeValue}%`"
                class="bg-velux-red w-16 h-8 rounded-full inline-flex items-center justify-center absolute transform -translate-y-1/2 top-1/2 -translate-x-8 cursor-pointer z-0 pointer-events-none shadow-md transition-all"
              >
                <div
                  class="grid gap-2 text-sm grid-cols-2 text-velux-white items-center"
                >
                  <i class="far fa-chevron-down transform rotate-90 mx-1-5"></i>
                  <i class="far fa-chevron-down transform -rotate-90 mx-1-5"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
    export default {
        props: ["count", "isMobile"],
        data() {
            return {
                rangeValue: 0,
                images: [],
            }
        },
        created() {
            if (window.document.beforeAfterImages.length > 0) {
                this.images = window.document.beforeAfterImages;
            }   
        },
        methods: {
            calculateValue(index) {
                const multiplier = this.images.length - 1;
                const offset = (1 / multiplier) * (index - 1);
                const percentage = this.rangeValue / 100;

                let currentUniqueValue = 0;

                if (percentage > offset) {
                    currentUniqueValue = (percentage - offset) * multiplier;
                }

                currentUniqueValue > 1 ? (currentUniqueValue = 1) : currentUniqueValue;
                return currentUniqueValue;
            },
            jumpToMin() {
                this.rangeValue = 0;
            },
            jumpToMax() {
                this.rangeValue = 100;
            },
        }
    }

</script>

<style scoped>
input[type="range"]::-webkit-slider-thumb {
  width: 1rem;
  -webkit-appearance: none;
  appearance: none;
  opacity: 0;
  z-index: 30;
}
</style>
